import React, { useContext } from "react";
import AuthContext from "../../store/auth-context";
import loGo from './../../Img/yuri.jpg';

export default function DoctorCvSection() {
    const ctx = useContext(AuthContext);
    const data = ctx.text?.drYuri;

    if (!data) return null;

    const renderPublications = (list) =>
        (list || []).map((item, idx) => {
            // Make DOI/links clickable (simple + safe)
            const parts = String(item).split(/(https?:\/\/[^\s]+)/g);
            return (
                <li key={idx} style={s.li}>
                    {parts.map((p, i) =>
                        p.startsWith("http") ? (
                            <a key={i} href={p} target="_blank" rel="noreferrer" style={s.link}>
                                {p}
                            </a>
                        ) : (
                            <span key={i}>{p}</span>
                        )
                    )}
                </li>
            );
        });

    return (
        <div style={s.root}>
            {/* Title */}
            <div style={s.sectionTitleWrap}>
                <div style={s.sectionTitleLine} />
                <h2 style={s.sectionTitle}>{data.teamTitle}</h2>
                <div style={s.sectionTitleLine} />
            </div>

            {/* Hero */}
            <div style={s.heroCard}>
                <img
                    src={loGo}
                    alt={data.name}
                    style={s.heroImg}
                />
                <div style={s.heroInfo}>
                    <div style={s.name}>{data.name}</div>
                    <div style={s.role}>{data.role}</div>
                </div>
            </div>

            {/* Ausbildung / Education */}
            <h3 style={s.h3}>{data.sections?.education}</h3>

            <div style={s.kvList}>
                {(data.education || []).map((row, idx) => (
                    <p key={idx} style={s.p}>
                        <strong>{row.label}</strong>: {row.text}
                    </p>
                ))}
            </div>

            {/* Klinische und wissenschaftliche Tätigkeit */}
            <h3 style={s.h3}>{data.sections?.clinical}</h3>

            <div style={s.tableWrap}>
                <table style={s.table}>
                    <tbody>
                        {(data.clinicalTable || []).map((row, idx) => (
                            <tr key={idx}>
                                <td style={s.tdYear}>{row.from}</td>
                                <td style={{ ...s.tdYear, textAlign: row.to === "至今" ? "center" : "left" }}>
                                    {row.to}
                                </td>
                                <td style={s.tdText}>{row.text}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Sprachen */}
            <h3 style={s.h3}>{data.sections?.languages}</h3>
            <p style={s.p}>{(data.languagesList || []).join(", ")}</p>

            {/* Kenntnisse */}
            <h3 style={s.h3}>{data.sections?.skills}</h3>
            {(data.skillsList || []).map((t, idx) => (
                <p key={idx} style={s.p}>
                    {t}
                </p>
            ))}

            {/* Akupunktur */}
            <h3 style={s.h3}>{data.sections?.acupuncture}</h3>
            {(data.acupunctureTraining || []).map((t, idx) => (
                <p key={idx} style={s.p}>
                    {t}
                </p>
            ))}

            {/* Publikationen */}
            <h3 style={s.h3}>{data.sections?.publications}</h3>
            <ol style={s.ol}>{renderPublications(data.publicationsList)}</ol>

            {/* Luftfahrt/ Raumfahrt / Marinenmedizin */}
            <h3 style={s.h3}>{data.sections?.aerospace}</h3>
            <ol style={s.ol}>{renderPublications(data.aerospaceList)}</ol>

            {/* Buchbeiträge */}
            <h3 style={s.h3}>{data.sections?.bookChapters}</h3>
            <ol style={s.ol}>{renderPublications(data.bookChaptersList)}</ol>

            {/* Patente / Einführungsprotokolle */}
            <h3 style={s.h3}>{data.sections?.patents}</h3>
            <ol style={s.ol}>{renderPublications(data.patentsList)}</ol>

            <div style={{ height: 8 }} />
        </div>
    );
}

const s = {
    root: {
        maxWidth: 980,
        margin: "0 auto",
        padding: "10px 12px 24px",
        color: "#1f2937",
        fontFamily:
            'system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif',
        lineHeight: 1.55,
    },

    sectionTitleWrap: {
        display: "grid",
        gridTemplateColumns: "1fr auto 1fr",
        gap: 14,
        alignItems: "center",
        margin: "8px 0 14px",
    },
    sectionTitleLine: {
        height: 1,
        background: "rgba(15, 23, 42, 0.12)",
    },
    sectionTitle: {
        margin: 0,
        fontSize: 22,
        fontWeight: 800,
        letterSpacing: 0.2,
        color: "#111827",
    },

    heroCard: {
        background: "#fff",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
        border: "1px solid rgba(15, 23, 42, 0.08)",
        marginBottom: 18,
    },
    heroImg: {
        width: "100%",
        height: "auto",
        display: "block",
    },
    heroInfo: {
        padding: "12px 14px 14px",
    },
    name: {
        fontSize: 16,
        fontWeight: 800,
        marginBottom: 2,
    },
    role: {
        fontSize: 13,
        opacity: 0.8,
    },

    h3: {
        margin: "18px 0 10px",
        fontSize: 20,
        fontWeight: 850,
        color: "#111827",
    },

    kvList: {
        background: "#fff",
        borderRadius: 14,
        padding: "12px 14px",
        border: "1px solid rgba(15, 23, 42, 0.08)",
        boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
    },

    p: {
        margin: "10px 0",
        fontSize: 14,
        color: "#374151",
    },

    tableWrap: {
        background: "#fff",
        borderRadius: 14,
        padding: 8,
        border: "1px solid rgba(15, 23, 42, 0.08)",
        boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
        overflowX: "auto",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: 14,
    },
    tdYear: {
        width: 110,
        padding: "10px 10px",
        verticalAlign: "top",
        color: "#4b5563",
        borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
        whiteSpace: "nowrap",
    },
    tdText: {
        padding: "10px 10px",
        verticalAlign: "top",
        color: "#374151",
        borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
    },

    ol: {
        background: "#fff",
        borderRadius: 14,
        padding: "12px 14px 12px 34px",
        border: "1px solid rgba(15, 23, 42, 0.08)",
        boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
        margin: "10px 0 0",
    },
    li: {
        margin: "8px 0",
        fontSize: 14,
        color: "#374151",
    },
    link: {
        color: "#2563eb",
        textDecoration: "none",
        wordBreak: "break-word",
    },
};